<template>
    <div class="mainBox">
        <van-nav-bar
            title="飞贷申请"
            />
        <van-cell-group class="groupBox">
          
             <!-- 输入飞贷申请额度 -->
            <van-field v-model="Amount" required label="飞贷申请额度"  placeholder="飞贷申请额度" >
                <template #button>
                    <van-button plain  type="info" size="mini">元</van-button>
                </template>
            </van-field>
        </van-cell-group>
        <van-cell-group class="groupBox">
            <!-- 输入客户姓名 -->
            <van-field v-model="CustomerName" required label="客户姓名" placeholder="请输入客户姓名"/>
             <!-- 输入客户身份证号 -->
            <van-field v-model="CustomerNumID" required label="客户身份证号"   placeholder="请输入客户身份证号"/>
            <!-- 输入客户手机号 -->
            <van-field v-model="CustomerMobile" required label="客户手机号" type="tel" placeholder="请输入客户手机号"/>
        </van-cell-group>
        <van-cell-group class="groupBox">
            <!-- 请输入公司名称 -->
            <van-field v-model="CompanyName" required label="公司名称" placeholder="请输入公司名称" />
             <!-- 请输入统一社会信用代码 -->
            <van-field v-model="CreditCode" required label="统一社会信用代码" placeholder="请输入统一社会信用代码"/>
            <!-- 请输入成立时间 -->
            <van-field v-model="Formed" required label="成立时间" placeholder="请选择成立时间" @click="FormedFun()"/>

 <!-- 请选择合作起始月份 -->
            <van-field v-model="cooStartMon" required label="合作起始月份" placeholder="请选择合作起始月份" @click="cooStartMonFun()"/>
 <van-popup v-model="showPickerYM" round position="bottom">
    <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        :title="title"
        :min-date="minDate"
        :max-date="maxDate"
         @cancel="showPickerYM = false"
           @confirm="onConfirmDate"
        />
</van-popup>
            <!-- 请输入企业电话 -->
            <van-field v-model="CompanyMobile" required label="企业电话" type="number" placeholder="请输入企业电话"/>
             <!-- 请输入企业地址 -->
            <van-field v-model="CompanyAddress" required label="企业地址" placeholder="请输入企业地址"  />
            <!-- 请输入所属行业 -->
            <van-field  readonly clickable :value="BelongBusiness" required label="所属行业" placeholder="请选择所属行业"    @click="BelongBusinessFun()"/>
            <van-popup v-model="showPicker" round position="bottom">
                <van-picker
                    show-toolbar
                    :title="title"
                    :columns="columns"
                    @cancel="showPicker = false"
                    @confirm="onConfirm"
                />
            </van-popup>


              <!-- 请输入与其所属企业关系 -->
            <van-field v-model="BelongRelation" required label="与其所属企业关系" placeholder="请选择与所属企业关系" @click="BelongRelationFun()"/>
        </van-cell-group>
         <van-cell-group class="groupBox">
            <!-- 请输入房产状态 -->
            <van-field v-model="HomeStatus"  label="房产状态" placeholder="请选择房产状态" @click="HomeStatusFun()"/>
             <!-- 请输入车辆型号 -->
            <van-field v-model="CarModel"  label="车辆型号" placeholder="请输入车辆型号"/>
            <!-- 请输入成立时间 -->
            <van-field v-model="CarNum"  label="车牌号" placeholder="请输入车牌号"/>
            <!-- 请选择上牌时间 -->
            <van-field v-model="LicensedTime"  label="上牌时间" placeholder="请选择上牌时间" @click="LicensedTimeFun()"/>
 <van-popup v-model="showPickerDate" round position="bottom">
    <van-datetime-picker
        v-model="currentDate"
        type="date"
        :title="title"
        :min-date="minDate"
        :max-date="maxDate"
         @cancel="showPickerDate = false"
           @confirm="onConfirmDate"
        />
</van-popup>



             <!-- 请输入车架号 -->
            <van-field v-model="CarVIN"  label="车架号" placeholder="请输入车架号"/>
            <!-- 请选择行驶里程 -->
            <van-field v-model="CarRange"  label="行驶里程" placeholder="请选择行驶里程"/>
              <!-- 请输入车辆评估价 -->
            <van-field v-model="CarPrice"  label="车辆评估价" placeholder="请输入车辆评估价"/>
        </van-cell-group>
        <p>请务必填写准确信息，资料信息越完整越有利于通过审核</p>
        <button  class="btn" @click="FromFun">填写完成，去认证</button>
        
    </div>
</template>

<script>
import {listDic,offlineCreditApply} from '../api/offlineCreditApply.js'
        
import {NavBar,DatetimePicker ,Toast ,Popup ,Picker ,Field,CellGroup,Button} from 'vant';
export default {
    name: "FlyloanData",
    components: {
         [NavBar.name]: NavBar,
        [Field.name]: Field,
        [Button.name]: Button,
        [CellGroup.name]: CellGroup,
        [Picker.name]: Picker,
        [Toast.name]: Toast,
        [Popup.name]: Popup,
        [DatetimePicker.name]: DatetimePicker,
    },
    data() {
        return {
            title:'',
            showPicker: false,
            showPickerDate: false,
            showPickerYM: false,
            columns: [],
            columnsArr:[],

      minDate: new Date(2010, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),

            Amount:'',//飞贷申请额度

            CustomerName:'',//客户姓名
            CustomerNumID:'',//客户身份证号
            CustomerMobile:'',//客户手机号

            CompanyName:'',//公司名称
            CreditCode:'',//统一社会信用代码
            Formed:'',//成立时间
            cooStartMon:'',//合作起始月份
            CompanyMobile:'',//企业电话
            CompanyAddress:'',//企业地址
            BelongBusiness :'',//所属行业
BelongBusinessCode:'',

            BelongRelation:'',//与其所属企业关系
BelongRelationCode:'',
            HomeStatus:'',// 房产状态
HomeStatusCode:'',
            CarModel:'',//车辆型号
            CarNum:'',//车牌号
            LicensedTime:'',//上牌时间
            CarVIN:'',//车架号
            CarRange:'',//行驶里程
            CarPrice:'',   //车辆评估价
        };
    },
    created() {
    },
    methods: {
        
        formatDateFun(date,cut,isTime) {
        var date = new Date(date);
        var YY = date.getFullYear() + cut;
        var MM =(date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + cut;
        var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        var hh =(date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
        var mm =(date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +":";
        var ss = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return YY + MM + DD + (isTime == true ?  " " + hh + mm + ss : "");
        },
        LicensedTimeFun(){
            this.showPickerDate=true
             this.title="选择上牌时间"
        },

        FormedFun(){
            this.showPickerDate=true
             this.title="选择成立时间"
        },
        cooStartMonFun(){
            this.showPickerYM=true
             this.title="选择合作起始月份"
        },
        onConfirmDate(picker) {
            if(this.title=="选择上牌时间"){
                this.showPickerDate=false;
                let date=this.formatDateFun(picker,"-",false)
                this.LicensedTime= date
                console.log('上牌时间',date)
            }else  if(this.title=="选择成立时间"){
                this.showPickerDate=false;
                let date=this.formatDateFun(picker,"-",false)
                this.Formed= date
            }else if (this.title=="选择合作起始月份"){
                this.showPickerYM=false
                 let date=this.formatDateFun(picker,"/",false).substring(0,7)
                this.cooStartMon=date
            }
        },
        BelongBusinessFun(){
            this.showPicker=true
            this.title="所属行业"
            listDic('I').then(
                 res=>{
                    this.columns=[],
                    this.columnsArr=res.data
                    this.columnsArr.forEach(item=>{
                        this.columns.push(item.name)
                    })
                    
                }
            )
        },
        BelongRelationFun(){
            this.showPicker=true
            this.title="与其所属企业关系"
            listDic('R').then(
                 res=>{
                    this.columns=[],
                    this.columnsArr=res.data
                    this.columnsArr.forEach(item=>{
                        this.columns.push(item.name)
                    })
                    
                }
            )
        },
        HomeStatusFun(){
            this.showPicker=true
            this.title="房产状态"
            listDic('PS').then(
                 res=>{
                    this.columns=[],
                    this.columnsArr=res.data
                    this.columnsArr.forEach(item=>{
                        this.columns.push(item.name)
                    })
                }
            )
        },
        onConfirm(picker,value) {
            this.showPicker=false;
            // Toast(`当前值：${picker}, 当前索引aaa：${this.columnsArr[value].id}`);
            if(this.title==="所属行业"){
               this.BelongBusiness=picker,
               this.BelongBusinessCode=this.columnsArr[value].id,
              console.log('所属行业',this.BelongBusinessCode)

            }else if (this.title==="与其所属企业关系"){
               this.BelongRelation=picker,
               this.BelongRelationCode=this.columnsArr[value].id
                console.log('与其所属企业关系',this.BelongRelationCode)
            }else if (this.title==="房产状态"){
               this.HomeStatus=picker,
               this.HomeStatusCode=this.columnsArr[value].id
                console.log('房产状态',this.BelongRelationCode)
            }

        },
     
        onCancel() {
            Toast('取消');
        },
        
        FromFun(){
           
            if(this.Amount==''){
              Toast("飞贷申请额度不能为空");
              return false
            }
            if(this.CustomerName==''){
              Toast("客户姓名不能为空");
              return false
            }
            if(this.CustomerNumID==''){
              Toast("客户身份证号不能为空");
              return false
            }
            if(this.CustomerMobile==''){
              Toast("客户手机号不能为空");
              return false
            }
            if(this.CompanyName==''){
              Toast("公司名称不能为空");
              return false
            }
            if(this.CreditCode==''){
              Toast("统一社会信用代码不能为空");
              return false
            }
            if(this.Formed==''){
              Toast("成立时间不能为空");
              return false
            }

            if(this.cooStartMon==''){
              Toast("合作起始月份不能为空");
              return false
            }
            if(this.CompanyMobile==''){
              Toast("企业电话不能为空");
              return false
            }
            if(this.CompanyAddress==''){
              Toast("企业地址不能为空");
              return false
            }
            if(this.BelongBusinessCode==''){
              Toast("所属行业不能为空");
              return false
            }
            if(this.BelongRelationCode==''){
              Toast("与其所属企业关系不能为空");
              return false
            }
            let data={
                companyAd:this.CompanyAddress,	//企业地址		true	 string
                companyTel:this.CompanyMobile,	//企业电话		true	string
                cooStartMon:this.cooStartMon,	//合作起始月份 格式为 YYYY/MM		true	string
                foundingTime:this.Formed,	//成立时间 YYYY-MM-DD		true	string
                idCardNo:this.CustomerNumID,	//客户身份证号		true	string
                industry:this.BelongBusinessCode,	//所属行业		true	string
                partnerApproveAmount:this.Amount,	//合作方审批额度		true	string
                relation:this.BelongRelationCode,	//借款人与其所属企业关系		true	string
                socialCreditCode:this.CreditCode,	//统一社会信用代码		true	string
                unitName:this.CompanyName,	//公司名称		true	string
                userMobile:this.CustomerMobile,	//手机号码		true	string
                userName:this.CustomerName,	//客户姓名		true	string
                appPrice:this.CarPrice,	//车辆评估价		false	string
                frameNumber:this.CarVIN,	//车架号		false	string
                licenseNumber:this.CarNum,	//车牌号		false	string
                licensingTime:this.LicensedTime,	//上牌时间 YYYY-MM-DD		false	string
                mileage:this.CarRange,	//行驶里程		false	string
                model:this.CarModel,	//车辆型号		false	string
                propertyStatus:this.HomeStatusCode,	//房产状态    false
            }
            offlineCreditApply(data).then(
                res=>{
                    console.log(res)
                    if(res.code==400){
                     Toast(res.msg);
                    }else{
                      Toast(res.msg);
                     location.reload();
                    }
                }
            )
        }
    },
    mounted() {

    }
}
</script>

<style  scoped>
.btn{
    width: 90%;
    border-radius:5px;
    outline: none;
    border: none;
    background: #FF3333;
    color: #fff;
    font-size: 15px;
    text-align: center;
    line-height: 40px;
    bottom: 60px;
    position: relative;
}
.van-field__label{
        width: 8.2em;
}
.van-cell__value{
    color: #ccc;
}
.mainBox{
    background: #f2f2f2;
}

.groupBox{
    background: #fff;
    padding: 0 10px;
    margin-bottom:16px;
}
p{
    color: #999999;
    font-size: 12px;
    text-align: center;
    line-height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/FlyloanData.vue